<template>
	<div :class="[{ 'is-survey': isSurvey }, {'is-not-survey': !isSurvey}]">
		<div class="text-response">
			<div class="response"
				v-for="(r, i) in response"
				:key="i">
				<FlagRecord
					v-if="questionnaire[i] && questionnaire[i].problem && isSurvey && getUserType != 'observer'"
					:question="question"
					:event="questionnaire[i]"
					:patient="patient">
				</FlagRecord>
				<EditUnit v-if="getUserType != 'observer' && cnstFrmCnntd === false" :question="question" :qDate="questionnaireDate(i)" :qNum="qNum" :response="r" :oresponse="getOResponse(i)" :event="questionnaire[i]" :patient="patient"></Editunit>
	
				<div :class="['date', {'no-answer-date': !r || !r[0]}]" v-if="response.length > 1">
					{{ questionnaireDate(i) }}
				</div>
				<div class="answer-wrapper">
					<UnitPartial :response="r"></UnitPartial>
				</div>
				<el-popover
					placement="left"
					width="400"
					trigger="click"
					:key="renderKey"
					v-if="isSurvey && getUserType === 'observer'"
					class="flag-modal">
					<button :disabled="comment.length != 0" :class="[showFlagDialog[i] ? 'flag-unresolved-button' : 'flag-button']" @click="addFlag(i)" slot="reference">
						<img :src="require(showFlagDialog[i] ? './icon/flag-unresolved.png' : './icon/flag.png')" class="flag-image"> Flag
						<span v-if="flagSavedText[i]" class="flag-saved-text">Flagged Successfully</span>
					</button>
					<div class="header">
						Add Comment
						<i class="el-icon-close" @click="closeModal(i)"></i>
					</div>
					<div class="add-comment">
						<el-input
							type="textarea"
							size="small"
							:rows="6"
							placeholder="Start typing..."
							:maxlength="150"
							v-model="comment">
						</el-input>
						<span class="char-left">
							{{ 150 - comment.length }} characters left
						</span>
					</div>
					<div class="dialog-footer">
						<LoadingButton type="primary" 
							@click="markFlagged(i)" style="width:105px; float: right;"
							:disabled="comment.length === 0"
							:loading="flagLoading">
							Done
						</LoadingButton>
						<el-button type="text" @click="closeModal(i)" class="cancel-button">Cancel</el-button>
					</div>
				</el-popover>
			</div>
		</div>
	</div>
</template>

<script>
import QuestionResponse from '.'
import { mapActions, mapGetters } from 'vuex'
import LoadingButton from '@/module/component/LoadingButton.vue'
import UnitPartial from './partialResponse/UnitPartial'

export default {
	extends: QuestionResponse,

	data() {
		return {
			comment: '',
			renderKey: 0,
			flagLoading: false,
			flagSavedText: this.response.map(_ => false),
			showFlagDialog: this.response.map(_ => false)
		}
	},

	methods: {
		...mapActions('outcome', ['addFlagging', 'resolveFlagging']),
		getOResponse(index) {
			return this.oresponse[index]
		},
		addFlag(index) {
			if (this.comment.length)
				return
			this.showFlagDialog[index] = true
		},
		getUploader(uploaderId) {
            if(this.getUser && this.getUser.id === uploaderId)
                return this.getUser.name
            return null
        },
		/**
		 *  Flag object schema to send while marking/resolving flag
		 * 	{
		 * 		id: uuidv4(),
				problem_id: 'string', // event.problem id sent only during resolving
				question_id: this.question.id,
				comment: this.comment,
				// comment_resolution: 'string', //comment after marking resolved
				type: 'problem', // problem or resolution
				auth: this.getUserId
			}
		 */
		markFlagged(index) {
			this.comment = this.comment.trim()
			if (this.comment.length === 0)
				return
			this.flagLoading = true
			this.addFlagging({
				id: this.questionnaire[index].id,
				question_id: this.question.id,
				comment: this.comment,
				type: 'problem',
				auth: this.getUserId,
				patientId: this.patient.id
			})
			.then((response) => {
				this.flagLoading = false
				this.flagSavedText[index] = true
				this.closeModal(index)
				setTimeout(() => {
					this.flagSavedText[index] = false
					this.renderKey += 1
				}, 3000)
				response.problem_id = this.questionnaire[index].id
				response.modified_name = this.getUploader(response.modified_by)
				this.$emit('addFlagObj', response)
			})
		},
		closeModal(index) {
			this.showFlagDialog[index] = false
			this.comment = ''
			this.renderKey += 1
		}
	},

	computed: {
		...mapGetters(['getUserType']),
		...mapGetters('user', ['getUser']),
		...mapGetters('auth', ['getUserId']),
		...mapGetters('provider', [ 'allPatientsChosen', 'getProviderNameById'])
	},
	
	components: {
		UnitPartial,
		LoadingButton
	}
}
</script>

<style lang="scss" scoped>
@import "./style.scss";
.text-response {
	min-height: 30px;
}
.response.with-date {
	padding-left: 80px;
}
.empty {
	opacity: 0.4;
}
</style>
